export default {
  devStoreConfig: false,
  api: {
    default: 'https://limitless-harbor-38712.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: true,
  }
};



// WEBPACK FOOTER //
// ./config/config.client13.js